#import "./CanvasBlockBaseFields.graphql"

fragment DocumentsBlockFields on DocumentsBlock {
  ...CanvasBlockBaseFields
  documents {
    id
    name
    contentType
    byteSize
  }
}
